
export default {
	mixins: [],
	props: [],
	components: {},
	data: function () {
		return {
			firstCall: true,
			card_ref: "",
			pin: "",
			submitted: false,
			first_name: "",
			last_name: "",
			email: "",
			consent_optins: [],
			api_errors_to_component_errors: {
				card_reference: "card_ref",
				pin: "pin",
				first_name: "first_name",
				last_name: "last_name",
				email: "email",
			},
		};
	},

	created: function () {
		this.updateConsentOptins();

		// pre-fill pin number
		if (this.$route.params.pin) this.pin = this.$route.params.pin;

		// pre-fill card reference
		if (this.$route.params.card_ref)
			this.card_ref = this.$route.params.card_ref;

		// keep route as /register and not /activation
		if (this.$route.name == "activation") {
			this.$router.replace({ name: "register" });
		}
	},
	mounted: function () { },

	watch: {
		consents(newVal) {
			this.updateConsentOptins();
		},
	},

	computed: {
		consents() {
			return this.$store.getters.getAccountConsents;
		},
	},
	methods: {
		submit() {
			this.$validator.validateAll().then((result) => {
				if (result) {
					this.registerCard();
				} else {
					this.scrollToError();
				}
			});
		},

		updateConsentOptins() {
			for (let i in this.consents) {
				if (
					!(this.consents[i].id in this.consent_optins) &&
					this.consents[i].is_active
				) {
					this.consent_optins.push({
						id: this.consents[i].id,
						optin: null,
						consent_copy: this.consents[i].consent_copy,
					});
				}
			}
		},

		registerCard(removeDashes = false) {
			this.submitted = true;

			//remove whitespace from the card number
			let cardRef = this.card_ref.replace(/\s+/g, "");

			//check if there are any dashes in the card number
			let dashSearchResult = /-/g.test(cardRef);

			//if this is the second call, remove dashes,
			if (removeDashes) {
				cardRef = cardRef.replace(/-/g, "");
			} else {
				if (!dashSearchResult) {
					//else, if no dashes found in card number,flick the bool so api call is only made once
					removeDashes = true;
				}
			}
			let params = { card_reference_input: cardRef, pin_input: this.pin };

			this.$axios({
				url: this.baseGraphURL,
				method: "post",
				data: {
					query: `
	                  mutation($card_reference:String!,$pin:String!,$first_name:String!,$last_name:String!,$email:String!,$consents:[ConsentInput]!){
	                      registerCard(card_reference:$card_reference,pin:$pin, first_name:$first_name, last_name:$last_name, email:$email, consents:$consents){
	                        card_reference
	                      },
	                  }
	                `,
					variables: {
						card_reference: cardRef,
						pin: this.pin,
						first_name: this.first_name,
						last_name: this.last_name,
						email: this.email,
						consents: this.consent_optins,
					},
				},
			})
				.then((result) => {

					this.submitted = false;

					if (
						this.validateGraphResponse(
							result.data,
							this.api_errors_to_component_errors
						)
					) {
						this.$router.push({ name: "balance", params: params });
					} else {
						if (!removeDashes) {
							//if there was an error and dashes were found in the card number, make second api call where dashes will be removed
							//and set firstcall to true so error message does not show.
							this.firstCall = true;
							this.registerCard(true);
						} else {
							//else if second call, set firstCall to false so error message shows
							this.firstCall = false;
							// Only the "we couldn't find that card/pin" case has its own inline message —
							// anything else (unexpected error, customer-facing error) still needs the modal
							if (!this.errors.has('card_ref') && !this.errors.has('pin')) {
								this.$bus.$emit('show_modal_alert', "Something has gone wrong, please try again.");
							}
						}
					}
				})
				.catch((error) => {
					this.submitted = false;
					// Check if it's a rate limit error (429)
					if (error.response && error.response.status === 429) {
						this.$modal.show('rate_limited_card_registration');
					} else {
						// Show general error modal for all other errors
						this.$bus.$emit('show_modal_alert', "Something has gone wrong, please try again.");
					}
				});
		},
	},

	head() {
		return {
			title: 'Register your gift card - ' + this.$store.getters.getAccount.name
		}
	}
};
